<ng-container
  *ngIf="{
    product: product$ | async,
  } as content"
>
  @if (!content.product) {
    <local-loader></local-loader>
  } @else {
    @if (content.product?.assetTypes?.length) {
      <ul>
        <li *ngFor="let item of content.product?.assetTypes">
          <a [href]="item.url" target="_blank" rel="noopener noreferrer">
            <span class="material-symbols-outlined"> download </span>
            <div class="box-titles">
              <span class="title">{{ item.type }}</span>
              <span class="sub-title">{{ item.value }}</span>
            </div>
          </a>
        </li>
      </ul>
    } @else {
      <p class="text-center">{{ 'resourceCenter.noContent' | cxTranslate }}</p>
    }
  }
</ng-container>
